import { IHeSoDieuChinh, ITimTuyenDuong } from "../_types_";
import axiosInstance from "./axios.instance";

export const layDanhSachHeSoDieuChinh = async (
  pageIndex: number = 1,
  pageSize: number = 20,
  lichSu = false,
  searchKey?: string
): Promise<IHeSoDieuChinh[]> => {
  const rs = await axiosInstance.get(`HeSoDieuChinh/v1`, {
    params: { pageIndex, pageSize, lichSu, searchKey },
  });
  //@ts-ignore
  return rs.items;
};

export const themMoiHeSoDieuChinh = async (body: IHeSoDieuChinh[]) => {
  return axiosInstance.post(`HeSoDieuChinh/v1`, body);
};

export const themMoiTimDuong = async (data: ITimTuyenDuong) => {
  return axiosInstance.post(
    `TimDuong?maHuyen=${data.huyen}&isOverWrite=false`,
    data
  );
};

export const themMoiRanhGioiDuong = async (data: ITimTuyenDuong) => {
  return axiosInstance.post(
    `RanhGioiDuong?maHuyen=${data.huyen}&isOverWrite=false`,
    data
  );
};
